/**
 * Conductor feature-toggle variant values. Conductor specs resolve to 'A'
 * (control/disabled) or 'B' (variant/enabled) — read them with
 * `experiments.get(key) === CONDUCTOR_FT.ENABLED`, not `experiments.enabled(key)`.
 *
 * Shared across all Conductor-gated toggles in this app. Note Conductor keys are
 * bare (e.g. `shouldEnablePostAuthRedirect`), without the legacy `specs.<owner>.`
 * Petri prefix.
 */
export const CONDUCTOR_FT = {
  ENABLED: 'B',
  DISABLED: 'A',
} as const;
